import React from 'react'
import img from '../Assets/Images/images/just_gamers_img.png'
import chart from '../Assets/Images/images/just_gamers_chart.png'
import classes from './Intro.module.css'

const Intro = () => {

    const handlePlayGames=()=>{
      window.scrollTo({
        top: 500,
        behavior: "smooth",
      }); // Scrolls to 500px down from the top

    }

  return (
   <section className="slider-bg relative flex justify-between">
      <div className='p-2 py-8'>
        <div className=" justify-start">
          <div className="">
            <div className="slider-content text-center">
              <h6 className="wow fadeInDown" data-wow-delay=".2s">
                Games
              </h6>
              <h2 className=" fix" data-in-effect="fadeInLeft">
              H2N<span>GAMES</span>
              </h2>
              <p className="wow fadeInUp" data-wow-delay="2s">
                FIND NEW GAMES BASED ON NEW TECHNOLOGY WHICH ARE FULL WITH FUN,
                ENTERTAINMENT AND KNOWLEDGE.
              </p>
              <button className='btn' data-wow-delay="2.2s"
                onClick={handlePlayGames}>
                Play Games
              </button>
            </div>
          </div>
        </div>
      </div>
      <img src={img} alt='' className={`absolute h-[23rem] bottom-0 right-[15rem] z-50 ${classes.intro_img}`}/>
      <img src={chart} alt='' className={`absolute h-[20rem] bottom-0 right-10 z-0 ${classes.intro_img}`}/>
    </section>
  )
}

export default Intro
